import React from "react";
import { InputGroup, Input, Button } from "reactstrap";

const SearchBox = ({ open, onChange, toggle, text }) => (
  <InputGroup>
    <div className="input-group-prepend">
      <span className="input-group-text">
        <i className="fa fa-search"></i>
      </span>
    </div>

    <Input
      type="text"
      placeholder="Search something"
      value={text}
      onChange={e => onChange({ text: e.target.value })}
    />
    {/* {!open && (
      <div className="input-group-append">
        <Button type="button" color="primary" onClick={() => toggle()}>
          Advanced <i className="fa fa-caret-down"></i>
        </Button>
      </div>
    )} */}
  </InputGroup>
);

export default SearchBox;
